'use strict';

class Accordion {
    setup (element = false) {
        this.accordionElement = element || $('.accordion');
        this.init();
        var _closeAllAcordion = this.closeAllAcordionItems;
        var _closeActiveAccordion = this.closeActiveAccordion;
        this.accordionElement.on('click', '.accordion-title:not(.disabled)', function (e) {
            e.preventDefault();
            if (!$(e.currentTarget).hasClass('js-find-in-store-btn')) {
                e.stopPropagation();
            }         
            const $accordion = $(this).closest('.accordion');
            const $item = $(this).closest('.accordion-item');
            const $content = $(this).next('.accordion-content');
            const breakpoint = $accordion.data('accordion-size');

            const closeAllOpenPanels = !$accordion.hasClass('multiple-panels') && !$(this).parent().hasClass('active');
            const closeActivePanel = $(this).parent().hasClass('active');

            if (breakpoint === 'small' && !Foundation.MediaQuery.atLeast('medium')) {
                if (closeAllOpenPanels) {
                    _closeAllAcordion($accordion);

                    $content.slideDown({
                        progress: function () {
                            if ($item.offset().top < ($(window).scrollTop() + $('header').height())) {
                                window.scrollTo(0, ($item.offset().top - $('header').height()));
                            }
                        }
                    });
                }

                $item.addClass('active');

                if (closeActivePanel) {
                    _closeActiveAccordion($item);
                }
            } else if (breakpoint === 'medium' && !Foundation.MediaQuery.atLeast('large')) {
                if (closeAllOpenPanels) {
                    _closeAllAcordion($accordion);
                }

                $item.addClass('active');
                $content.slideDown({
                    progress: function () {
                        if ($item.offset().top < ($(window).scrollTop() + $('header').height())) {
                            window.scrollTo(0, ($item.offset().top - $('header').height()));
                        }
                    }
                });
            } else if (breakpoint === 'tablet' && !Foundation.MediaQuery.atLeast('large')) {
                if (closeAllOpenPanels) {
                    _closeAllAcordion($accordion);
                }

                $item.addClass('active');
                $content.slideDown({
                    progress: function () {
                        if ($item.offset().top < ($(window).scrollTop() + $('header').height())) {
                            window.scrollTo(0, ($item.offset().top - $('header').height()));
                        }
                    }
                });
            } else if (breakpoint === 'all') {
                if (closeAllOpenPanels) {
                    _closeAllAcordion($accordion);
                    $('body').trigger('accordion:breakpoint-all-expanded', $item);
                }

                $item.addClass('active');
                $content.slideDown({
                    progress: function () {
                        if ($item.offset().top < ($(window).scrollTop() + $('header').height())) {
                            window.scrollTo(0, ($item.offset().top - $('header').height()));
                        }
                    }
                });
            }
        });
        this.accordionElement.on('keydown', '.accordion-title:not(.disabled)', function (e) {
            if (e.type === 'keydown' && e.originalEvent.code === 'Enter') {
                $(e.currentTarget).trigger('click');
            }
        });
        // close at click
        this.accordionElement.on('click', '.accordion-item.active .accordion-title', function (e) {
            e.preventDefault();
            $(e.currentTarget).siblings('.accordion-content').slideUp('fast');
            $(e.currentTarget).closest('.accordion-item').removeClass('active');
        });

        $(window).on('changed.zf.mediaquery', () => {
            this.init();
        });

        this.accordionElement.find('.accordion-item[data-open-on-init="true"]').find('.accordion-title').trigger('click');
    }

    init () {
        this.accordionElement.each(function () {
            const $accordion = $(this).closest('.accordion');
            const breakpoint = $accordion.data('accordion-size');

            if (breakpoint === 'small' && !Foundation.MediaQuery.atLeast('medium')) {
                $accordion.addClass('initialized');
                $accordion.find('.accordion-content').hide();
            } else if (breakpoint === 'medium' && !Foundation.MediaQuery.atLeast('large')) {
                $accordion.addClass('initialized');
                $accordion.find('.accordion-content').hide();
            } else if (breakpoint === 'tablet' && !Foundation.MediaQuery.atLeast('large')) {
                $accordion.addClass('initialized');
                $accordion.find('.accordion-content').hide();
            } else if (breakpoint !== 'all') {
                $accordion.removeClass('initialized');
                $accordion.find('.accordion-content').show();
            } else if (breakpoint === 'all') {
                $accordion.addClass('initialized');
                $accordion.find('.accordion-content').hide();
            }
        });
    }

    closeAllAcordionItems ($accordionContainer) {
        $accordionContainer.find('.accordion-content').slideUp('fast');
        $accordionContainer.find('.accordion-item').removeClass('active');
    }

    closeActiveAccordion ($accordionItem) {
        $accordionItem.removeClass('active');
        $accordionItem.find('.accordion-content').slideUp('fast');
    }
}

const accordion = new Accordion();
export default accordion;
